import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import NavTab from '~spa/Components/NavTab';

import {
    BB_RACING_WIDGET_TABS_CLASS,
} from '../../constants';

const propTypes = {
    type: PropTypes.string,
    racingContext: PropTypes.any,
    scheduleUpdate: PropTypes.func,
};

const TypeTabs = ({ racingContext, scheduleUpdate }) => {
    const { t } = useTranslation();
    const featuredSelected = racingContext.featured;
    const nextSelected = !racingContext.featured;

    return (
        <div className={BB_RACING_WIDGET_TABS_CLASS}>
            <NavTab
                items={[
                    { label: t('racing.featured'), selected: featuredSelected, fluid: true },
                    { label: t('racing.next_races'), selected: nextSelected, fluid: true },
                ]}
                onTabSelected={scheduleUpdate}
            />
        </div>
    );
};

TypeTabs.propTypes = propTypes;

export default TypeTabs;
